import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { DeviceEffects } from "./device.effects";

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature([DeviceEffects])],
})
export class DeviceModule {}
